import React from 'react'
import Hero from '../Components/Hero/Hero'
import Collection from '../Components/Collection/Collection'
import Popular from '../Components/Popular/Popular'

const Home = () => {
  return (
    <div>
      <Popular />
      <Hero />
      <Collection />
      {/*<NewsLetter />*/}
    </div>
  )
}

export default Home